'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';

interface MobileViewContextType {
  mobileMode: boolean;
}

const MobileViewContext = createContext<MobileViewContextType>({
  mobileMode: false,
});

export function MobileViewProvider({ children }: { children: React.ReactNode }) {
  const [mobileMode, setMobileMode] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 640px)');
    setMobileMode(mq.matches);
    const handler = (e: MediaQueryListEvent) => setMobileMode(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return (
    <MobileViewContext.Provider value={{ mobileMode }}>
      {children}
    </MobileViewContext.Provider>
  );
}

export function useMobileView() {
  return useContext(MobileViewContext);
}
